import styled from 'styled-components'

import { helpers } from 'styles'

export const Subtitle = styled.div`
	display: flex;
	align-items: center;
	column-gap: 6px;
	font-size: ${helpers.font.size.large};
	font-weight: 500;
	margin-bottom: 16px;

	> svg {
		color: ${helpers.color.secondary};
	}
`
